export default __webpack_public_path__ + "static/media/image5.e8c301e0.jpg";